import { useContext, useEffect, useState } from 'react'
import secureLocalStorage from 'react-secure-storage';
import { showToast } from '../../showTost';
import axios from 'axios';
import { MyContext } from '../../Context/MyProvider';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import Razorpay from '../../Payment/Razorpay';
import Paypal from '../../Payment/Paypal';
import Stripe from '../../Payment/Stripe';
import PayStack from '../../Payment/PayStack';
import FlutterWave from '../../Payment/FlutterWave';
import PaytmPayment from '../../Payment/Paytm';
import MercadoPago from '../../Payment/MercadoPago';
import PayFast from '../../Payment/PayFast';
import Midtrans from '../../Payment/Midtrans';
import KhaltiPayment from '../../Payment/KhaltiPayment';
const Wallet = () => {

    const { BaseUrl, paymentloading, paymentRes, setPaymentRes, setPaymentLoading } = useContext(MyContext);

    const [walletamt, setWalletAmt] = useState(0);
    const [loading, setLoading] = useState(true);
    const [historylist, setHistoryList] = useState([]);
    const [apiloading, setApiLoading] = useState(false);
    const [isverify, setIsVerify] = useState(false);
    const [isdetails, setIsDetails] = useState(false);
    const [formdata, setFormData] = useState({ fname: "", lname: "", dob: "", number: "" });
    const [error, setError] = useState(false);
    const [isgtype, setIsGType] = useState(false);
    const [selectgtype, setSelectGType] = useState("");
    const [gtypedata, setGTypeData] = useState("");
    const [isdatepicker, setIsDatePicker] = useState(false);
    const [sendotp, setSendOtp] = useState("");
    const [inputotp, setInputOtp] = useState("");
    const [isresponsive, setIsResponsive] = useState(false);
    const [paymentlist, setPaymentList] = useState([]);
    const [ispaymentbox, setIsPaymentBox] = useState(false);
    const [selectpayment, setSelectPayment] = useState("");
    const [attributes, setAttributes] = useState("");
    const [inputamt, setInputAmt] = useState("");
    const [istrue, setIsTrue] = useState(false);

    const Currency = secureLocalStorage.getItem("currency");
    const Today = new Date();

    useEffect(() => {

        const LoginData = secureLocalStorage.getItem("Logindata");
        if (LoginData) {
            const { is_verify, ccode, mobile } = JSON.parse(LoginData);
            const number = `${String(ccode)}${String(mobile)}`;
            setFormData({ ...formdata, number });
            if (is_verify === "0") {
                setIsVerify(true);
            }
        }

        const WalletAmt = secureLocalStorage.getItem("walletamt");
        setWalletAmt(WalletAmt);

        const PaymentRes = sessionStorage.getItem("Paymentstatus");

        if (PaymentRes) {
            if (PaymentRes === "PaymentDone") {
                setPaymentRes("PaymentDone");
            } else {
                setPaymentRes("PaymentFail");
            }
        }

        handleGetPaymentList();
        handleGetHistory();
    }, []);

    const handleGetPaymentList = () => {
        const uid = secureLocalStorage.getItem("Userid");

        axios.post(`${BaseUrl}/eapi/e_paymentgateway.php`, { uid })
            .then((res) => {
                // console.log("e_paymentgateway.php", res.data);
                setPaymentList(res.data.paymentdata);
            })
            .catch((error) => {
                console.error("e_paymentgateway.php", error);
            });
    }

    const handleGetHistory = () => {
        const uid = secureLocalStorage.getItem("Userid");

        axios.post(`${BaseUrl}/eapi/e_wallet_report.php`, { uid })
            .then((res) => {
                // console.log("e_wallet_report.php", res.data);
                setHistoryList(res.data.Walletitem);
                setWalletAmt(res.data.wallet);
                secureLocalStorage.setItem("walletamt", res.data.wallet);
                setLoading(false);
            })
            .catch((error) => {
                console.error("e_wallet_report.php", error);
            });
    }

    const handleConfirmDetails = () => {
        const { fname, lname, dob, number } = formdata;

        if (!fname || !lname || !dob || !number || !selectgtype || !gtypedata) {
            showToast({ title: "Please fill all details !!", id: "error" });
            setError(true);
            return;
        }

        setApiLoading(true);

        const LoginData = secureLocalStorage.getItem("Logindata");

        if (LoginData) {

            const { ccode, mobile } = JSON.parse(LoginData);

            axios.post(`${BaseUrl}/eapi/e_mobile_check.php`, { mobile, ccode })
                .then((res) => {
                    console.log(res);
                    if (res.data.ResponseCode === "401") {
                        if (res.data.otp_auth === "No") {
                            handleActivateWallet();
                        } else {
                            axios.post(`${BaseUrl}/eapi/send_otp.php`, { mobile, ccode })
                                .then((res) => {
                                    console.log("send_otp.php", res);
                                    const { Result, otp } = res.data;
                                    if (Result === "true") {
                                        showToast({ title: "Otp send successfuly !!", id: "success" });
                                        setSendOtp(otp);
                                        setInputOtp(otp);
                                    }
                                    setApiLoading(false);
                                })
                                .catch((error) => {
                                    console.error("send_otp.php", error);
                                });
                        }
                    }
                })
                .catch((error) => {
                    console.error("e_mobile_check.php", error);
                });

        }
    }

    const handleVerifyOtp = () => {

        if (!inputotp) {
            showToast({ title: "Please enter OTP !!", id: "error" });
            setError(true);
            return;
        }

        handleActivateWallet();
    };

    const handleActivateWallet = () => {
        const { fname, lname, dob, number } = formdata;
        const uid = secureLocalStorage.getItem("Userid");
        setApiLoading(true);

        const ApiData = {
            uid,
            fname,
            lname,
            mobile: number,
            dob,
            title: selectgtype,
            gnum: gtypedata
        }

        axios.post(`${BaseUrl}/eapi/e_wallet_activate.php`, ApiData)
            .then((res) => {
                // console.log("e_wallet_activate.php", res);
                const { ResponseCode, ResponseMsg, UserLogin } = res.data;
                const Toastid = ResponseCode === "200" ? "success" : "error";
                showToast({ title: ResponseMsg, id: Toastid });
                if (ResponseCode === "200") {
                    secureLocalStorage.setItem("Logindata", JSON.stringify(UserLogin));
                    setIsVerify(false);
                }
                setApiLoading(false);
            })
            .catch((error) => {
                console.error("e_wallet_activate.php", error);
            });
    }

    const handleDateChange = (newDate) => {
        setFormData({ ...formdata, dob: newDate.format('YYYY-MM-DD') });
        setIsDatePicker(false);
    };

    const handleActivateMoney = () => {
        setIsDetails(true);

        if (window.innerWidth < 770) {
            setIsResponsive(true);
        }
    }

    const handleContinue = () => {
        if (!inputamt) {
            showToast({ title: "Please enter amount !!", id: "error" });
            return;
        }

        if (!selectpayment) {
            showToast({ title: "Select payment method !!", id: "error" });
            return;
        }

        secureLocalStorage.setItem("pages", "wallet")
        secureLocalStorage.setItem("Amount", inputamt);
        setPaymentLoading(true);
        setIsTrue(true);
    }

    useEffect(() => {
        if (!paymentRes) return;

        if (paymentRes === "PaymentDone") {
            handleAddWallet();
        } else {
            showToast({ title: "Payment faild !!", id: "error" });
            setIsTrue(false);
            setSelectPayment("");
            setPaymentRes("");
            setInputAmt("");
            secureLocalStorage.removeItem("Amount");
            sessionStorage.removeItem("transactionid");
            sessionStorage.removeItem("Paymentstatus");
        }
    }, [paymentRes]);

    const handleAddWallet = () => {
        const uid = secureLocalStorage.getItem("Userid");
        const wallet = secureLocalStorage.getItem("Amount");

        axios.post(`${BaseUrl}/eapi/e_wallet_up.php`, { uid, wallet })
            .then((res) => {
                // console.log("e_wallet_up.php", res.data);
                const { ResponseCode, ResponseMsg } = res.data
                const Toastid = ResponseCode === "200" ? "success" : "error";
                showToast({ title: ResponseMsg, id: Toastid });
                secureLocalStorage.removeItem("Amount");
                sessionStorage.removeItem("transactionid");
                sessionStorage.removeItem("Paymentstatus");
                setIsTrue(false);
                setSelectPayment("");
                setPaymentRes("");
                setIsPaymentBox(false);
                setInputAmt("");
                handleGetHistory();
            })
            .catch((error) => {
                console.error("e_wallet_up.php", error);
            })
    }

    return (
        <div onClick={() => isgtype && setIsGType(false)} className='wallet_page'>
            {loading
                ? <div className="w-full h-[calc(100vh-90px)] bg-white z-[777] fixed flex items-center justify-center">
                    <div className="loader"></div>
                </div>
                : <div className="width_container">

                    {!isverify && <div className="">
                        <div className="section_1">
                            <div className='leading-5'>
                                <h1 className='font-[500] text-[18px]'>Available Balance</h1>
                                <h1 className='font-bold text-[19px]'>{Currency + walletamt}</h1>
                            </div>
                            <button onClick={() => setIsPaymentBox(true)} className="flex items-center gap-[10px] bg-[--bgcolor] p-[7px] rounded-[50px]">
                                <div className="bg-white rounded-full p-[5px]">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.5301 10.5301C19.3841 10.6761 19.192 10.7501 19 10.7501C18.808 10.7501 18.616 10.6771 18.47 10.5301L12.75 4.81017V21.0001C12.75 21.4141 12.414 21.7501 12 21.7501C11.586 21.7501 11.25 21.4141 11.25 21.0001V4.81115L5.53005 10.5311C5.23705 10.8241 4.76202 10.8241 4.46902 10.5311C4.17602 10.2381 4.17602 9.76309 4.46902 9.47009L11.469 2.47009C11.538 2.40109 11.6209 2.34622 11.7129 2.30822C11.8959 2.23222 12.1029 2.23222 12.2859 2.30822C12.3779 2.34622 12.4611 2.40109 12.5301 2.47009L19.5301 9.47009C19.8231 9.76309 19.8231 10.2371 19.5301 10.5301Z" fill="#25314C" />
                                    </svg>
                                </div>
                                <h1 className='text-white font-[600] text-[17px]'>Top Up</h1>
                            </button>
                        </div>

                        <h1 className='font-[500] text-[18px] my-[20px]'>Transaction History</h1>

                        <div className="section_2">
                            {historylist.length >= 1
                                ? historylist.map((item, index) => {
                                    return <div key={index} className="history_box">
                                        <div className="flex items-center gap-[20px]">
                                            <div className={`${item.status === "Credit" ? "text-green-500 bg-green-200" : "text-[red] bg-red-200"} p-[10px] rounded-full`}>
                                                {item.status === "Credit"
                                                    ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11.9402 2.20983L9.5302 7.81983H7.1202C6.7202 7.81983 6.3302 7.84983 5.9502 7.92983L6.9502 5.52983L6.9902 5.43983L7.0502 5.27983C7.0802 5.20983 7.1002 5.14983 7.1302 5.09983C8.2902 2.40983 9.5902 1.56983 11.9402 2.20983Z" fill="currentColor"></path>
                                                        <path d="M18.7301 8.09002L18.7101 8.08002C18.1101 7.91002 17.5001 7.82002 16.8801 7.82002H10.6201L12.8701 2.59002L12.9001 2.52002C13.0401 2.57002 13.1901 2.64002 13.3401 2.69002L15.5501 3.62002C16.7801 4.13002 17.6401 4.66002 18.1701 5.30002C18.2601 5.42002 18.3401 5.53002 18.4201 5.66002C18.5101 5.80002 18.5801 5.94002 18.6201 6.09002C18.6601 6.18002 18.6901 6.26002 18.7101 6.35002C18.8601 6.86002 18.8701 7.44002 18.7301 8.09002Z" fill="currentColor"></path>
                                                        <path d="M18.2902 9.51982C17.8402 9.38982 17.3702 9.31982 16.8802 9.31982H7.12023C6.44023 9.31982 5.80023 9.44982 5.20023 9.70982C3.46023 10.4598 2.24023 12.1898 2.24023 14.1998V16.1498C2.24023 16.3898 2.26023 16.6198 2.29023 16.8598C2.51023 20.0398 4.21023 21.7398 7.39023 21.9498C7.62023 21.9798 7.85023 21.9998 8.10023 21.9998H15.9002C19.6002 21.9998 21.5502 20.2398 21.7402 16.7398C21.7502 16.5498 21.7602 16.3498 21.7602 16.1498V14.1998C21.7602 11.9898 20.2902 10.1298 18.2902 9.51982ZM14.5002 16.1898H12.7502V17.9998C12.7502 18.4098 12.4102 18.7498 12.0002 18.7498C11.5902 18.7498 11.2502 18.4098 11.2502 17.9998V16.1898H9.50023C9.09023 16.1898 8.75023 15.8598 8.75023 15.4398C8.75023 15.0298 9.09023 14.6898 9.50023 14.6898H11.2502V12.9998C11.2502 12.5898 11.5902 12.2498 12.0002 12.2498C12.4102 12.2498 12.7502 12.5898 12.7502 12.9998V14.6898H14.5002C14.9102 14.6898 15.2502 15.0298 15.2502 15.4398C15.2502 15.8598 14.9102 16.1898 14.5002 16.1898Z" fill="currentColor"></path>
                                                    </svg>
                                                    : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11.9402 2.20983L9.5302 7.81983H7.1202C6.7202 7.81983 6.3302 7.84983 5.9502 7.92983L6.9502 5.52983L6.9902 5.43983L7.0502 5.27983C7.0802 5.20983 7.1002 5.14983 7.1302 5.09983C8.2902 2.40983 9.5902 1.56983 11.9402 2.20983Z" fill="currentColor"></path>
                                                        <path d="M18.7301 8.09002L18.7101 8.08002C18.1101 7.91002 17.5001 7.82002 16.8801 7.82002H10.6201L12.8701 2.59002L12.9001 2.52002C13.0401 2.57002 13.1901 2.64002 13.3401 2.69002L15.5501 3.62002C16.7801 4.13002 17.6401 4.66002 18.1701 5.30002C18.2601 5.42002 18.3401 5.53002 18.4201 5.66002C18.5101 5.80002 18.5801 5.94002 18.6201 6.09002C18.6601 6.18002 18.6901 6.26002 18.7101 6.35002C18.8601 6.86002 18.8701 7.44002 18.7301 8.09002Z" fill="currentColor"></path>
                                                        <path d="M18.2902 9.51982C17.8402 9.38982 17.3702 9.31982 16.8802 9.31982H7.12023C6.44023 9.31982 5.80023 9.44982 5.20023 9.70982C3.46023 10.4598 2.24023 12.1898 2.24023 14.1998V16.1498C2.24023 16.3898 2.26023 16.6198 2.29023 16.8598C2.51023 20.0398 4.21023 21.7398 7.39023 21.9498C7.62023 21.9798 7.85023 21.9998 8.10023 21.9998H15.9002C19.6002 21.9998 21.5502 20.2398 21.7402 16.7398C21.7502 16.5498 21.7602 16.3498 21.7602 16.1498V14.1998C21.7602 11.9898 20.2902 10.1298 18.2902 9.51982ZM14.5002 16.7498H9.50023C9.09023 16.7498 8.75023 16.4098 8.75023 15.9998C8.75023 15.5898 9.09023 15.2498 9.50023 15.2498H14.5002C14.9102 15.2498 15.2502 15.5898 15.2502 15.9998C15.2502 16.4098 14.9102 16.7498 14.5002 16.7498Z" fill="currentColor"></path>
                                                    </svg>}
                                            </div>
                                            <div className='leading-6'>
                                                <h1 className='font-[500] text-[19px]'>{item.message}</h1>
                                                <p className='font-[500] text-[14px] text-gray-600'>{item.status} | {item.tdate}</p>
                                            </div>
                                        </div>
                                        <div className={item.status === "Credit" ? "text-green-500" : "text-[red]"}>
                                            <p className='font-bold text-[17px]'>{item.status === "Credit" ? "+" : "-"} {Currency + item.amt}</p>
                                        </div>
                                    </div>
                                })
                                : <div className="h-[300px] w-full flex items-center justify-center">
                                    <h1 className='font-bold text-[17px] text-gray-500'>Sorry, Transaction History List Empty !!</h1>
                                </div>
                            }
                        </div>

                    </div>}

                    {isverify && <div className="flex items-center justify-center pt-[20px]">
                        <div className="w-full flex items-start justify-center gap-[100px] max-_995_:gap-[20px]">

                            {!isresponsive && <div className="w-[500px] bg-white rounded-[12px] overflow-hidden scroll_container">
                                <div className="bg-[--bgcolor] p-[20px] flex items-center justify-center rounded-b-[15px]">
                                    <div className="text-white">
                                        <div className='text-center leading-[27px]'>
                                            <h1 className='font-bold text-[30px]'>Zuppr Money</h1>
                                            <span className='text-[14px] font-[500]'>Powered by cscodetech</span>
                                        </div>

                                        <div className='mt-[30px] mb-[20px]'>
                                            <div className="flex items-center gap-[10px]">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M15.3899 5.20979L16.7999 8.02979C16.9899 8.41979 17.4999 8.78979 17.9299 8.86979L20.4799 9.28979C22.1099 9.55979 22.4899 10.7398 21.3199 11.9198L19.3299 13.9098C18.9999 14.2398 18.8099 14.8898 18.9199 15.3598L19.4899 17.8198C19.9399 19.7598 18.8999 20.5198 17.1899 19.4998L14.7999 18.0798C14.3699 17.8198 13.6499 17.8198 13.2199 18.0798L10.8299 19.4998C9.11994 20.5098 8.07994 19.7598 8.52994 17.8198L9.09994 15.3598C9.18994 14.8798 8.99994 14.2298 8.66994 13.8998L6.67994 11.9098C5.50994 10.7398 5.88994 9.55979 7.51994 9.27979L10.0699 8.85979C10.4999 8.78979 11.0099 8.40979 11.1999 8.01979L12.6099 5.19979C13.3799 3.67979 14.6199 3.67979 15.3899 5.20979Z" fill="white" />
                                                    <path d="M8 5.75H2C1.59 5.75 1.25 5.41 1.25 5C1.25 4.59 1.59 4.25 2 4.25H8C8.41 4.25 8.75 4.59 8.75 5C8.75 5.41 8.41 5.75 8 5.75Z" fill="white" />
                                                    <path d="M5 19.75H2C1.59 19.75 1.25 19.41 1.25 19C1.25 18.59 1.59 18.25 2 18.25H5C5.41 18.25 5.75 18.59 5.75 19C5.75 19.41 5.41 19.75 5 19.75Z" fill="white" />
                                                    <path d="M3 12.75H2C1.59 12.75 1.25 12.41 1.25 12C1.25 11.59 1.59 11.25 2 11.25H3C3.41 11.25 3.75 11.59 3.75 12C3.75 12.41 3.41 12.75 3 12.75Z" fill="white" />
                                                </svg>
                                                <h1 className='text-[18px] font-[500]'>Fast & Easy Payments</h1>
                                            </div>

                                            <div className="flex items-center gap-[10px] mt-[10px]">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M15.3899 5.20979L16.7999 8.02979C16.9899 8.41979 17.4999 8.78979 17.9299 8.86979L20.4799 9.28979C22.1099 9.55979 22.4899 10.7398 21.3199 11.9198L19.3299 13.9098C18.9999 14.2398 18.8099 14.8898 18.9199 15.3598L19.4899 17.8198C19.9399 19.7598 18.8999 20.5198 17.1899 19.4998L14.7999 18.0798C14.3699 17.8198 13.6499 17.8198 13.2199 18.0798L10.8299 19.4998C9.11994 20.5098 8.07994 19.7598 8.52994 17.8198L9.09994 15.3598C9.18994 14.8798 8.99994 14.2298 8.66994 13.8998L6.67994 11.9098C5.50994 10.7398 5.88994 9.55979 7.51994 9.27979L10.0699 8.85979C10.4999 8.78979 11.0099 8.40979 11.1999 8.01979L12.6099 5.19979C13.3799 3.67979 14.6199 3.67979 15.3899 5.20979Z" fill="white" />
                                                    <path d="M8 5.75H2C1.59 5.75 1.25 5.41 1.25 5C1.25 4.59 1.59 4.25 2 4.25H8C8.41 4.25 8.75 4.59 8.75 5C8.75 5.41 8.41 5.75 8 5.75Z" fill="white" />
                                                    <path d="M5 19.75H2C1.59 19.75 1.25 19.41 1.25 19C1.25 18.59 1.59 18.25 2 18.25H5C5.41 18.25 5.75 18.59 5.75 19C5.75 19.41 5.41 19.75 5 19.75Z" fill="white" />
                                                    <path d="M3 12.75H2C1.59 12.75 1.25 12.41 1.25 12C1.25 11.59 1.59 11.25 2 11.25H3C3.41 11.25 3.75 11.59 3.75 12C3.75 12.41 3.41 12.75 3 12.75Z" fill="white" />
                                                </svg>
                                                <h1 className='text-[18px] font-[500]'>Instant Refunds</h1>
                                            </div>

                                            <div className="flex items-center gap-[10px] mt-[10px]">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M15.3899 5.20979L16.7999 8.02979C16.9899 8.41979 17.4999 8.78979 17.9299 8.86979L20.4799 9.28979C22.1099 9.55979 22.4899 10.7398 21.3199 11.9198L19.3299 13.9098C18.9999 14.2398 18.8099 14.8898 18.9199 15.3598L19.4899 17.8198C19.9399 19.7598 18.8999 20.5198 17.1899 19.4998L14.7999 18.0798C14.3699 17.8198 13.6499 17.8198 13.2199 18.0798L10.8299 19.4998C9.11994 20.5098 8.07994 19.7598 8.52994 17.8198L9.09994 15.3598C9.18994 14.8798 8.99994 14.2298 8.66994 13.8998L6.67994 11.9098C5.50994 10.7398 5.88994 9.55979 7.51994 9.27979L10.0699 8.85979C10.4999 8.78979 11.0099 8.40979 11.1999 8.01979L12.6099 5.19979C13.3799 3.67979 14.6199 3.67979 15.3899 5.20979Z" fill="white" />
                                                    <path d="M8 5.75H2C1.59 5.75 1.25 5.41 1.25 5C1.25 4.59 1.59 4.25 2 4.25H8C8.41 4.25 8.75 4.59 8.75 5C8.75 5.41 8.41 5.75 8 5.75Z" fill="white" />
                                                    <path d="M5 19.75H2C1.59 19.75 1.25 19.41 1.25 19C1.25 18.59 1.59 18.25 2 18.25H5C5.41 18.25 5.75 18.59 5.75 19C5.75 19.41 5.41 19.75 5 19.75Z" fill="white" />
                                                    <path d="M3 12.75H2C1.59 12.75 1.25 12.41 1.25 12C1.25 11.59 1.59 11.25 2 11.25H3C3.41 11.25 3.75 11.59 3.75 12C3.75 12.41 3.41 12.75 3 12.75Z" fill="white" />
                                                </svg>
                                                <h1 className='text-[18px] font-[500]'>No document upload required</h1>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className="p-[20px]">
                                    <div className='mt-[10px]'>
                                        <p className='text-center leading-[18px] text-[15px] font-[500] text-gray-600'>Activate Wallet by entering any Govemment ID number (PAN, Driving License, Passport, etc.)</p>
                                        <p className='text-center leading-[18px] text-[14px] mt-[15px] font-[500] text-gray-600'>By continuing, you agree to our Terms & Conditioni</p>
                                        <button onClick={handleActivateMoney} className='bg-[#f86723] w-full mt-[10px] py-[10px] text-white font-bold rounded-[10px]'>ACTIVATE MONEY</button>
                                    </div>

                                    <div className="mt-[15px]">
                                        <h1 className='font-bold text-[18px]'>Note</h1>
                                        <p className='leading-[18px] text-[14px] font-[500] text-gray-600 mt-[5px]'>• To activate Wallet, as per RBI regulations, nen ICICI Bank customers are required to enter a Government ID number (PAN, Passport, Driving Licence etc.) as a min. KYC. However, ICICI Bank customers are axempt from this as their KYC details are with the bank.</p>
                                        <p className='leading-[18px] text-[14px] font-[500] text-gray-600 mt-[10px]'>• Any balance in an activated Wallet account cannot be transferred to a bank account as per RBI guidelines.</p>
                                        <p className='leading-[18px] text-[14px] font-[500] text-gray-600 mt-[10px]'>• You can use Wallet only to pay for restaurant orders on Swiggy currently. Wallet will soon be available to pay for Grocery, Genie and POP orders tool</p>
                                    </div>
                                </div>
                            </div>}

                            {isdetails && <div className={`w-[400px] ${(isdetails && !isresponsive) ? "max-_770_:hidden" : ""}`}>
                                <div className="flex items-center gap-[10px]">
                                    <button onClick={() => { setIsDetails(false); setIsResponsive(false); }}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                                        </svg>
                                    </button>
                                    <h1 className='font-[500] text-[17px]'>Activate Money</h1>
                                </div>
                                <div className='mt-[10px]'>

                                    <div className="relative mb-[20px]">
                                        <input value={formdata.fname} onChange={(e) => setFormData({ ...formdata, fname: e.target.value })}
                                            type="text"
                                            id="First Name"
                                            placeholder=""
                                            className="peer w-full border-b font-bold border-gray-400 outline-none pt-[15px] pb-[2px]"
                                        />
                                        <label style={{ color: (error && !formdata.fname) && "red" }}
                                            htmlFor="First Name"
                                            className={`absolute left-[0px] text-gray-500 font-medium transition-all duration-200 cursor-text
                  ${!formdata.fname
                                                    ? 'peer-placeholder-shown:top-4 peer-placeholder-shown:text-base'
                                                    : 'top-0 text-xs'} peer-focus:-top-[0px] peer-focus:text-xs`}
                                        >
                                            {(error && !formdata.fname) ? "ENTER FIRST NAME" : "FIRST NAME"}
                                        </label>
                                    </div>

                                    <div className="relative mb-[20px]">
                                        <input value={formdata.lname} onChange={(e) => setFormData({ ...formdata, lname: e.target.value })}
                                            type="text"
                                            id="Last Name"
                                            placeholder=""
                                            className="peer w-full border-b font-bold border-gray-400 outline-none pt-[15px] pb-[2px]"
                                        />
                                        <label style={{ color: (error && !formdata.lname) && "red" }}
                                            htmlFor="Last Name"
                                            className={`absolute left-[0px] text-gray-500 font-medium transition-all duration-200 cursor-text
                  ${!formdata.lname
                                                    ? 'peer-placeholder-shown:top-4 peer-placeholder-shown:text-base'
                                                    : 'top-0 text-xs'} peer-focus:-top-[0px] peer-focus:text-xs`}
                                        >
                                            {(error && !formdata.lname) ? "ENTER LAST NAME" : "LAST NAME"}
                                        </label>
                                    </div>

                                    <div className="relative mb-[20px]">
                                        <h1 className="peer w-full border-b font-bold border-gray-400 outline-none pb-[2px] pt-[15px]">{formdata?.number}</h1>
                                        <label
                                            htmlFor="number"
                                            className={`absolute left-[0px] text-gray-500 font-medium transition-all duration-200 cursor-text
                  ${!formdata.number
                                                    ? 'peer-placeholder-shown:top-4 peer-placeholder-shown:text-base'
                                                    : '-top-[0px] text-xs'} peer-focus:-top-[0px] peer-focus:text-xs`}
                                        >
                                            MOBILE NUMBER
                                        </label>
                                    </div>

                                    <div className="relative mb-[20px]">
                                        <div onClick={() => setIsDatePicker(true)} className="flex justify-center items-end border-b border-gray-400 cursor-pointer">
                                            <h1 id='dob' className={`${!formdata.dob ? "mt-[20px]" : ""} peer w-full font-bold outline-none pt-[15px] pb-[2px]`}>{formdata.dob}</h1>
                                            <label style={{ color: (error && !formdata.dob) && "red" }}
                                                htmlFor="dob"
                                                className={`absolute left-[0px] text-gray-500 font-medium transition-all duration-200 cursor-pointer
                  ${!formdata.dob
                                                        ? 'peer-placeholder-shown:top-4 peer-placeholder-shown:text-base'
                                                        : '-top-[0px] text-xs'} peer-focus:-top-[0px] peer-focus:text-xs`}
                                            >
                                                {(error && !formdata.dob) ? "ENTER DATE OF BIRTH" : "DATE OF BIRTH"}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="relative mb-[20px]">
                                        <div onClick={() => setIsGType(true)} className="flex justify-center items-end border-b border-gray-400 cursor-pointer">
                                            <h1 id='Government id' className={`${!selectgtype ? "mt-[20px]" : ""} peer w-full font-bold outline-none pt-[15px] pb-[2px]`}>{selectgtype}</h1>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.698 15.396L6.3181 10.2019C5.5821 9.3289 6.20603 8 7.35203 8H16.6479C17.7939 8 18.4179 9.3299 17.6819 10.2019L13.302 15.396C12.623 16.201 11.377 16.201 10.698 15.396Z" fill="#25314C" />
                                            </svg>
                                            <label style={{ color: (error && !selectgtype) && "red" }}
                                                htmlFor="Government id"
                                                className={`absolute left-[0px] text-gray-500 font-medium transition-all duration-200 cursor-pointer
                  ${!selectgtype
                                                        ? 'peer-placeholder-shown:top-4 peer-placeholder-shown:text-base'
                                                        : '-top-[0px] text-xs'} peer-focus:-top-[0px] peer-focus:text-xs`}
                                            >
                                                {(error && !selectgtype) ? "ENTER GOVRNMENT ID" : "GOVRNMENT ID"}
                                            </label>

                                            {isgtype && <div style={{ boxShadow: "-1px 5px 20px 0px rgba(0, 0, 0, 0.226)" }} className="w-full absolute top-[50px] rounded-[5px] overflow-hidden z-[555]">
                                                <div className="bg-white text-[14px] font-[500]">
                                                    {["PAN", "DRIVING LICENSE", "PASSPORT", "VOTER ID", "AADHAR"].map((item, index) => {
                                                        return <p key={index} onClick={() => { setSelectGType(item); setIsGType(false); setGTypeData(""); }} className='cursor-pointer py-[5px] hover:bg-[#f2f6fc] px-[15px]'>{item}</p>
                                                    })}
                                                </div>
                                            </div>}

                                        </div>
                                    </div>

                                    {selectgtype && <div className="relative mb-[20px]">
                                        <input value={gtypedata} onChange={(e) => setGTypeData(e.target.value)}
                                            type="text"
                                            id="selectdata"
                                            placeholder=""
                                            className="peer w-full border-b font-bold border-gray-400 outline-none pt-[15px] pb-[2px]"
                                        />
                                        <label style={{ color: (error && !gtypedata) && "red" }}
                                            htmlFor="selectdata"
                                            className={`absolute left-[0px] text-gray-500 font-medium transition-all duration-200 cursor-text
                  ${!gtypedata
                                                    ? 'peer-placeholder-shown:top-4 peer-placeholder-shown:text-base'
                                                    : 'top-0 text-xs'} peer-focus:-top-[0px] peer-focus:text-xs`}
                                        >
                                            {(error && !gtypedata) ? `ENTER ${selectgtype}` : selectgtype}
                                        </label>
                                    </div>}

                                    {sendotp && <div className="relative mb-[20px]">
                                        <input value={inputotp} onChange={(e) => setInputOtp(e.target.value)}
                                            type="text"
                                            id="selectdata"
                                            placeholder=""
                                            className="peer w-full border-b font-bold border-gray-400 outline-none pt-[15px] pb-[2px]"
                                        />
                                        <label style={{ color: (error && !inputotp) && "red" }}
                                            htmlFor="selectdata"
                                            className={`absolute left-[0px] text-gray-500 font-medium transition-all duration-200 cursor-text
                  ${!inputotp
                                                    ? 'peer-placeholder-shown:top-4 peer-placeholder-shown:text-base'
                                                    : 'top-0 text-xs'} peer-focus:-top-[0px] peer-focus:text-xs`}
                                        >
                                            {(error && !inputotp) ? "ENTER OTP" : "OTP"}
                                        </label>
                                    </div>}

                                </div>

                                <button onClick={sendotp ? handleVerifyOtp : handleConfirmDetails} className='bg-[#f86723] w-full mt-[10px] py-[10px] text-white font-bold rounded-[10px]'>
                                    {apiloading
                                        ? <div className="btn_loader mx-auto"></div>
                                        : <span>{sendotp ? "VERIFY OTP" : "CONFIRM DETAILS"}</span>}
                                </button>
                            </div>}

                        </div>
                    </div>}

                </div>}

            {isdatepicker && <div onClick={() => setIsDatePicker(false)} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} className='select_date'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                            components={[
                                'DatePicker',
                                'MobileDatePicker',
                                'DesktopDatePicker',
                                'StaticDatePicker',
                            ]}
                        >
                            <DemoItem label="Static variant">
                                <StaticDatePicker
                                    defaultValue={!formdata.dob ? dayjs(Today) : dayjs(formdata.dob)}
                                    onChange={handleDateChange}
                                    onClose={() => setIsDatePicker(false)}
                                />
                            </DemoItem>
                        </DemoContainer>
                    </LocalizationProvider>
                </div>
            </div>}

            {ispaymentbox && <div onClick={() => setIsPaymentBox(false)} className="model items-end">
                <div onClick={(e) => e.stopPropagation()} className="bg-white w-[450px] rounded-t-[10px]">

                    <div className="px-[20px]">
                        <h1 className="font-[500] text-[17px] pt-[5px] text-gray-900">Add Wallet Amount</h1>
                        <div className="border-[2px] focus-within:border-[--bgcolor] rounded-[10px] px-[15px] mt-[5px]">
                            <div className="flex items-center gap-[10px]">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.75 6.297V6C18.75 3.582 17.418 2.25 15 2.25H5C3.483 2.25 2.25 3.483 2.25 5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V10C21.75 7.845 20.692 6.553 18.75 6.297ZM20.25 15.75H16.5C15.535 15.75 14.75 14.965 14.75 14C14.75 13.035 15.535 12.25 16.5 12.25H20.25V15.75ZM5 3.75H15C16.577 3.75 17.25 4.423 17.25 6V6.25H5C4.311 6.25 3.75 5.689 3.75 5C3.75 4.311 4.311 3.75 5 3.75ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V7.44897C4.125 7.64097 4.55 7.75 5 7.75H18C19.577 7.75 20.25 8.423 20.25 10V10.75H16.5C14.708 10.75 13.25 12.208 13.25 14C13.25 15.792 14.708 17.25 16.5 17.25H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM17.01 13H17.02C17.573 13 18.02 13.448 18.02 14C18.02 14.552 17.573 15 17.02 15C16.468 15 16.015 14.552 16.015 14C16.015 13.448 16.458 13 17.01 13Z" fill="#25314C" />
                                </svg>
                                <input
                                    type="number"
                                    value={inputamt}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value >= 0) {
                                            setInputAmt(value);
                                        }
                                    }}
                                    className='w-full outline-none py-[8px] font-[500]'
                                    placeholder='Enter Amount'
                                />
                            </div>
                        </div>
                    </div>

                    <h1 className="font-[500] text-[17px] px-[20px] pt-[5px] text-gray-600">Select Payment Method</h1>
                    <div className="h-[400px] px-[20px] scroll_container">
                        {paymentlist?.map((item, index) => {
                            const isSelect = item.id === selectpayment;
                            if (item.status === "1" && item.p_show === "1") {
                                return <div key={index} onClick={() => { setSelectPayment(item.id); setAttributes(item.attributes) }} className={`payment_box border-[2px] ${isSelect ? "border-[--bgcolor]" : ""}`}>
                                    <div className="flex items-center gap-[10px]">
                                        <img src={`${BaseUrl}/${item.img}`} className="w-[65px] max-h-[65px] border-[2px] rounded-[20px]" alt="img" />
                                        <div className="">
                                            <h1 className="font-[500] text-[17px]">{item.title}</h1>
                                            <p className="text-[15px] text-gray-600 font-[500] leading-[18px]">{item.subtitle}</p>
                                        </div>
                                    </div>
                                    <div className="w-[30px]">
                                        <div className={`w-[18px] h-[18px] rounded-full border-[2px] p-[2px] duration-[.5s] ${isSelect ? "border-[--bgcolor]" : ""}`}>
                                            <div className={`w-full h-full rounded-full duration-[.5s] ${isSelect ? "bg-[--bgcolor]" : "bg-transparent"}`}></div>
                                        </div>
                                    </div>
                                </div>
                            }
                        })}
                    </div>

                    <div className=" bg-white py-[10px] px-[20px]">
                        <button onClick={handleContinue} className="w-full text-white rounded-[5px] font-bold text-[17px] bg-[--bgcolor] py-[10px] hover:shadow-[0,5px,8px,rgba(2,6,12,.2)]">
                            {paymentloading
                                ? <div className="btn_loader mx-auto"></div>
                                : <span>CONTINUE</span>}
                        </button>
                    </div>
                </div>
            </div>}

            {(selectpayment === "1" && istrue) && <Razorpay Amount={inputamt} attributes={attributes} />}
            {(selectpayment === "3" && istrue) && <div onClick={() => { setSelectPayment(""); setIsTrue(false) }} className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <Paypal Amount={inputamt} attributes={attributes} />
                    </div>
                </div>
            </div>}
            {(selectpayment === "4" && istrue) && <div onClick={() => { setSelectPayment(""); setIsTrue(false) }} className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <Stripe Amount={inputamt} />
                    </div>
                </div>
            </div>}
            {(selectpayment === "6" && istrue) && <PayStack Amount={inputamt} attributes={attributes} />}
            {(selectpayment === "7" && istrue) && <FlutterWave Amount={inputamt} attributes={attributes} />}
            {(selectpayment === "8" && istrue) && <PaytmPayment Amount={inputamt} />}
            {(selectpayment === "11" && istrue) && <MercadoPago Amount={inputamt} />}
            {(selectpayment === "12" && istrue) && <PayFast Amount={inputamt} attributes={attributes} />}
            {(selectpayment === "13" && istrue) && <Midtrans Amount={inputamt} />}
            {(selectpayment === "15" && istrue) && <KhaltiPayment Amount={inputamt} />}

        </div >
    )
}

export default Wallet